<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import Table from '../common/SortedTable.vue'

export default {
    name: 'MachinesComponent',

    components: {
        Table
    },

    props: {
        machines: {
            type: Array,
            requiered: true
        },
        selectedItems: {
            type: Array,
            default: () => []
        },
        languageStrings: {
            type: Object,
            default: null
        },
        role: {
            type: Number,
            default: 0
        },
        isLinde: {
            type: Boolean,
            default: false
        },
        localLanguages: {
            type: Object,
            default: null
        }
    },

    emits: ['selected-machines', 'double-click'],

    computed: {
        headers() {
            let h = [
                {
                    id: '',
                    name: 'A   S',
                    sort: false
                },
                {
                    id: 'name',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine001 != null ? this.languageStrings.ui.machine001 : 'Název'),
                    sort: true
                },
                {
                    id: 'folder',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine002 != null ? this.languageStrings.ui.machine002 : 'Složka'),
                    sort: true
                },
                {
                    id: 'machine-id',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine003 != null ? this.languageStrings.ui.machine003 : 'ID stroje'),
                    sort: true
                },
                {
                    id: 'manufacturer',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine004 != null ? this.languageStrings.ui.machine004 : 'Výrobce'),
                    sort: true
                },
                {
                    id: 'machine-type',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine005 != null ? this.languageStrings.ui.machine005 : 'Typ stroje'),
                    sort: true
                },
                {
                    id: 'model',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine006 != null ? this.languageStrings.ui.machine006 : 'Model'),
                    sort: true
                },
                {
                    id: 'year-of-manufacture',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine007 != null ? this.languageStrings.ui.machine007 : 'Rok výroby'),
                    sort: true
                },
                {
                    id: 'oil-volume',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine008 != null ? this.languageStrings.ui.machine008 : 'Objem oleje (l / kg)'),
                    sort: true
                },
                {
                    id: 'oil-manufacturer',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine009 != null ? this.languageStrings.ui.machine009 : 'Výrobce oleje'),
                    sort: true
                },
                {
                    id: 'oil-brand',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine010 != null ? this.languageStrings.ui.machine010 : 'Značka oleje'),
                    sort: true
                },
                {
                    id: 'oil-type',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine011 != null ? this.languageStrings.ui.machine011 : 'Typ oleje'),
                    sort: true
                },
                {
                    id: 'oil-viscosity-class',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine012 != null ? this.languageStrings.ui.machine012 : 'VT oleje'),
                    sort: true
                },
                {
                    id: 'last-sampling',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine013 != null ? this.languageStrings.ui.machine013 : 'Posl. odběr'),
                    sort: true,
                    sortType: 'date'
                },
                {
                    id: 'medium',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine014 != null ? this.languageStrings.ui.machine014 : 'Médium'),
                    sort: true
                },
                {
                    id: 'comment',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine015 != null ? this.languageStrings.ui.machine015 : 'Poznámka'),
                    sort: true,
                    width: 300
                }
            ]

            if (this.role > 1 && this.role < 5) {
                h.push({
                    id: 'uin-als',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine018 != null ? this.languageStrings.ui.machine018 : 'UIN'),
                    sort: true
                })
                if (this.isLinde) {
                    h.push({
                        id: 'tag-linde',
                        name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine019 != null ? this.languageStrings.ui.machine019 : 'Tag LINDE'),
                        sort: true
                    })
                }
                h.push({
                    id: 'uid',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.machine020 != null ? this.languageStrings.ui.machine020 : 'UID'),
                    sort: true
                })
            }

            return h
        },
        rows() {
            let r = []

            for (let i = 0; i < this.machines.length; i++) {
                r.push({
                    id: this.machines[i].id,
                    selected: (this.selectedItems.findIndex(x => x === this.machines[i].id) !== -1),
                    cells: [
                        {
                            id: '',
                            align: 'center',
                            contenttype: 'html',
                            content: (this.getStateImages(this.machines[i]))
                        },
                        {
                            id: 'name',
                            contenttype: 'text',
                            content: (this.machines[i].name != null ? this.machines[i].name : '')
                        },
                        {
                            id: 'folder',
                            contenttype: 'text',
                            content: (this.machines[i].folder != null ? this.machines[i].folder.name : '')
                        },
                        {
                            id: 'machine-id',
                            contenttype: 'text',
                            content: (this.machines[i].customerId != null ? this.machines[i].customerId : '')
                        },
                        {
                            id: 'manufacturer',
                            contenttype: 'text',
                            content: (this.machines[i].producer != null ? this.machines[i].producer : '')
                        },
                        {
                            id: 'machine-type',
                            contenttype: 'text',
                            content: (this.machines[i].type != null ? this.localLanguages.machineTypes.find(mt => mt.id === this.machines[i].type) != null ? this.localLanguages.machineTypes.find(mt => mt.id === this.machines[i].type).name : '' : '')
                        },
                        {
                            id: 'model',
                            contenttype: 'text',
                            content: (this.machines[i].model != null ? this.machines[i].model : '')
                        },
                        {
                            id: 'year-of-manufacture',
                            contenttype: 'text',
                            content: (this.machines[i].yearProduced != null ? this.machines[i].yearProduced : '')
                        },
                        {
                            id: 'oil-volume',
                            contenttype: 'text',
                            content: (this.machines[i].volume != null ? this.machines[i].volume : '')
                        },
                        {
                            id: 'oil-manufacturer',
                            contenttype: 'text',
                            content: (this.machines[i].oilProducer != null ? this.machines[i].oilProducer : '')
                        },
                        {
                            id: 'oil-brand',
                            contenttype: 'text',
                            content: (this.machines[i].oilBrand != null ? this.machines[i].oilBrand : '')
                        },
                        {
                            id: 'oil-type',
                            contenttype: 'text',
                            content: (this.machines[i].oilType != null ? this.localLanguages.oilTypes.find(ot => ot.id === this.machines[i].oilType.id) != null ? this.localLanguages.oilTypes.find(ot => ot.id === this.machines[i].oilType.id).name : '' : '')
                        },
                        {
                            id: 'oil-viscosity-class',
                            contenttype: 'text',
                            content: (this.machines[i].machineOil != null ? this.machines[i].machineOil.name : '')
                        },
                        {
                            id: 'last-sampling',
                            contenttype: 'text',
                            content: (this.machines[i].lastCollection != null ? this.formatDate(this.machines[i].lastCollection) : '')
                        },
                        {
                            id: 'medium',
                            contenttype: 'text',
                            content: (this.machines[i].medium != null ? this.machines[i].medium : '')
                        },
                        {
                            id: 'comment',
                            contenttype: 'text',
                            width: 300,
                            content: (this.machines[i].description != null ? this.machines[i].description : '')
                        }
                    ]
                })                

                if (this.role > 1 && this.role < 5) {
                    r[i].cells.push({
                        id: 'uin-als',
                        contenttype: 'text',
                        content: (this.machines[i].uinals != null ? this.machines[i].uinals : '')
                    })
                    if (this.isLinde) {
                        r[i].cells.push({
                            id: 'tag-linde',
                            contenttype: 'text',
                            content: (this.machines[i].tagLinde != null ? this.machines[i].tagLinde : '')
                        })
                    }
                    r[i].cells.push({
                        id: 'uid',
                        contenttype: 'text',
                        content: (this.machines[i].uid != null ? this.machines[i].uid : '')
                    })
                }
            }
            
            return r
        }
    },
    
    methods: {
        formatDate(date) {
            return date !== null ? dayjs(date + 'Z').utcOffset(0).format('D.M.YYYY') : ''
        },
        setSelectedMachines(value) {
            this.$emit('selected-machines', value)
        },
        doubleClick(value) {
            this.$emit('double-click', value)
        },
        getStateImages(machine) {
            let im = ''

            if (machine.state == null) {
                return im
            }

            switch (machine.stateTwo) {
                case 0:
                    im += '<img src="' + require('@/assets/images/circle-green.svg') + '" height="15px" />'
                    break
                case 1:
                    im = '<img src="' + require('@/assets/images/circle-yellow.svg') + '" height="15px" />'
                    break
                case 2:
                    im = '<img src="' + require('@/assets/images/circle-orange.svg') + '" height="15px" />'
                    break
                case 3:
                    im = '<img src="' + require('@/assets/images/circle-red.svg') + '" height="15px" />'
                    break
                default:
                    im = '<img src="' + require('@/assets/images/circle-white.svg') + '" height="15px" />'
            }

            im += '&nbsp'
            let s = machine.state.split(';')
            if (s.length > 1) {
                switch (s[1]) {
                    case '0':
                        im += '<img src="' + require('@/assets/images/circle-red.svg') + '" height="15px" />'
                        break
                    case '1':
                        im += '<img src="' + require('@/assets/images/circle-yellow.svg') + '" height="15px" />'
                        break
                    case '2':
                        im += '<img src="' + require('@/assets/images/circle-green.svg') + '" height="15px" />'
                        break
                    case '3':
                        im += '<img src="' + require('@/assets/images/circle-orange.svg') + '" height="15px" />'
                        break
                    case '4':
                        im += '<img src="' + require('@/assets/images/x-grey.svg') + '" height="15px" />'
                        break
                    default:
                        im += '<img src="' + require('@/assets/images/circle-grey.svg') + '" height="15px" />'
                }
            }
            else
                im += '<img src="' + require('@/assets/images/circle-white.svg') + '" height="15px" />'

            return im
        }
    }
}
</script>


<template>
    <Table v-if="machines.length > 0" :headers="headers" :rows="rows" :multiselect="true" @selected-items="setSelectedMachines" @double-click="doubleClick" />
</template>